const Footer = () => (
  <footer className="fixed-bottom footer mt-auto py-2 bg-light">
    <div className="container text-center small">
      <span className="text-muted">2022-2025 © Policoders Soluções em TI </span>
      <span className="text-muted">(env: {process.env.REACT_APP_ENV ?? 'development'})</span>
    </div>
  </footer>
);

export default Footer;
